import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { CustomDivider } from '../Utils/CustomDivider';
import { Title } from './Title';
import { Card } from './Card';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { BigButton } from 'Images';
import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { IEntitlement, getEntitlements } from 'API/compassRights';
import { ServerError } from '../ServerError';

export const UserRights = () => {
  const [userRights, setUserRights] = useState<IEntitlement[]>([]);
  const [isServerError, setIsServerError] = useState<boolean>(false);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userRights;
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const initCompassRights = useCallback(async () => {
    const entitlementsResult = await getEntitlements();
    if (
      (entitlementsResult?.status === 200 ||
        entitlementsResult?.status === 204) &&
      entitlementsResult?.data?.userEntitlements
    ) {
      setUserRights(entitlementsResult.data.userEntitlements);
    } else {
      setIsServerError(true);
    }
  }, []);

  useEffect(() => {
    initCompassRights();
  }, [initCompassRights, imposterId]);

  return userRights && userRights.length > 0 ? (
    <Stack sx={{ position: 'relative', mb: '48px' }}>
      <Box
        sx={
          isDesktop
            ? undefined
            : {
                position: 'absolute',
                height: 'calc(100% + 48px)',
                width: '100vw',
                top: '-24px',
                right: '-24px',
                bgcolor: 'primary.shade_200',
                zIndex: -1,
              }
        }
      />
      <Typography variant='h5'>{dictionary.title}</Typography>
      <CustomDivider />
      <Stack
        sx={
          isDesktop
            ? {
                backgroundColor: '#fff',
                mt: 2,
                p: '24px 32px 32px 32px',
                borderRadius: '16px',
              }
            : {
                backgroundColor: 'primary.shade_200',
                mt: 2,
                p: 0,
                height: 'auto',
              }
        }
      >
        <Title
          count={userRights.length || 0}
          displayCount={userRights?.slice(0, 3).length || 0}
        />

        <Stack
          mt={'16px'}
          flexDirection={isDesktop ? 'row' : 'column'}
          gap={'24px'}
          alignItems={isDesktop ? undefined : 'center'}
        >
          {userRights &&
            userRights
              ?.slice(0, 3)
              .map((right, index) => (
                <Card key={right.entitlementTypeId} {...right} />
              ))}
        </Stack>
        <Button
          onClick={() => navigate('/compass-rights')}
          endIcon={
            <Avatar
              sx={{ height: '50px', width: '46px', mt: '6px' }}
              src={BigButton}
              alt=''
            />
          }
          sx={{ p: 0, width: 'fit-content', m: '20px auto' }}
        >
          <Typography variant='body5'>{dictionary.toCompassRights}</Typography>
        </Button>
      </Stack>
    </Stack>
  ) : isServerError ? (
    <ServerError />
  ) : (
    <></>
  );
};
